function CookiePage() {
  function getSubmitButton() {
    return document.querySelector(`button[data-cookie-action="saveChoices"]`);
  }

  function setCheckboxesChecked(checked) {
    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"]:not([required])`,
    );
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  const cookieDialog = document.querySelector('[data-show-dialog="cookie"]');
  if (cookieDialog) {
    cookieDialog.showModal();
    cookieDialog.focus();
  }  

  document.addEventListener("click", (e) => {
    const target = e.target.closest('button');

    if (!(target instanceof HTMLButtonElement)) {
      return;
    }

    if (target.dataset.cookieAction == "acceptNecessary") {
      setCheckboxesChecked(false);
      getSubmitButton()?.click();
    }

    if (target.dataset.cookieAction == "acceptAll") {
      setCheckboxesChecked(true);
      getSubmitButton()?.click();
    }
  });
}

export const isCookieDialogOpen = () =>
  document.querySelector('[data-show-dialog="cookie"]')?.open === true;

export default CookiePage;
